export const VERTICAL_GUTTER_SIZE_PX = 40;
export const HORIZONTAL_GUTTER_SIZE_PX = 20;
export const PAGE_HEIGHT = 792;
export const PDF_WIDTH_PERCENTAGE = 50.5;
export const PDF_HEIGHT_PERCENTAGE = 94;
export const OBSERVER_THRESHOLD_PERCENTAGE = 0.4;
export const PDF_HEADER_SIZE_PX = 126;
export const PDF_SIDEBAR_SIZE_PX = 80;